var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPing1 = function SvgIconPing1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_ping_(1)_svg2__a",
    x1: 29.7,
    x2: 104.93,
    y1: 77.39,
    y2: 30.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__b",
    x1: 39.54,
    x2: 114.77,
    y1: 93.15,
    y2: 46.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__c",
    x1: 15.26,
    x2: 90.49,
    y1: 54.28,
    y2: 7.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__d",
    x1: 10.91,
    x2: 86.14,
    y1: 47.31,
    y2: 0.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__e",
    x1: 2.55,
    x2: 77.79,
    y1: 33.94,
    y2: -13.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__f",
    x1: 14.27,
    x2: 89.51,
    y1: 52.7,
    y2: 5.71
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__g",
    x1: 24.5,
    x2: 99.73,
    y1: 69.07,
    y2: 22.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__h",
    x1: 31.02,
    x2: 106.26,
    y1: 79.52,
    y2: 32.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__i",
    x1: 20.8,
    x2: 96.03,
    y1: 63.15,
    y2: 16.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__j",
    x1: 18.17,
    x2: 93.4,
    y1: 58.94,
    y2: 11.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_ping_(1)_svg2__a",
    id: "icon_ping_(1)_svg2__k",
    x1: 27.13,
    x2: 102.36,
    y1: 73.28,
    y2: 26.29
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M75 45.93c-.86 0-1.56.7-1.56 1.56v4.07h3.12v-4.07c0-.86-.7-1.56-1.56-1.56",
    style: {
      fill: "url(#icon_ping_(1)_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75 54.69H48.44c-3.45 0-6.25 2.8-6.25 6.25v25c0 3.45 2.8 6.25 6.25 6.25h16.41v4.69h-2.34c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56H79.7c.86 0 1.56-.7 1.56-1.56s-.7-1.56-1.56-1.56h-2.34v-4.69h16.41c3.45 0 6.25-2.8 6.25-6.25v-25c0-3.45-2.8-6.25-6.25-6.25ZM74.22 96.88h-6.25v-4.69h6.25zm22.66-10.94c0 1.73-1.4 3.12-3.12 3.12H48.45c-1.73 0-3.12-1.4-3.12-3.12v-25c0-1.73 1.4-3.12 3.12-3.12h45.31c1.73 0 3.12 1.4 3.12 3.12z",
    style: {
      fill: "url(#icon_ping_(1)_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.44 47.49c0-.23-.05-.46-.15-.66-.47.03-.94.04-1.41.04s-.94-.02-1.41-.04q-.15.315-.15.66v5.01c0 .86.7 1.56 1.56 1.56s1.56-.7 1.56-1.56z",
    style: {
      fill: "url(#icon_ping_(1)_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.51 23.44c0-.86-.7-1.56-1.56-1.56h-4.07c0 1.04-.07 2.09-.2 3.12h4.27c.86 0 1.56-.7 1.56-1.56",
    style: {
      fill: "url(#icon_ping_(1)_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 21.88C43.75 9.79 33.96 0 21.88 0S0 9.79 0 21.88s9.79 21.88 21.88 21.88c12.08-.01 21.86-9.8 21.88-21.88ZM29.13 39.16c1.91-2.97 3.2-6.3 3.78-9.78 2.44-.47 4.81-1.29 7.01-2.44-1.56 5.5-5.53 9.99-10.79 12.22m1.04-12.45c-2.74.43-5.52.64-8.29.63-2.78 0-5.55-.2-8.29-.63-.4-3.21-.4-6.46 0-9.68 2.74-.43 5.52-.64 8.29-.63 2.78 0 5.55.2 8.29.63a39.2 39.2 0 0 1 0 9.68m3.22-.65c.14-1.35.21-2.75.21-4.19s-.07-2.83-.21-4.19c4.59 1.15 7.24 2.85 7.24 4.19s-2.65 3.04-7.24 4.19m6.53-9.25a25.7 25.7 0 0 0-7.01-2.44c-.58-3.48-1.87-6.81-3.78-9.78 5.26 2.22 9.23 6.72 10.79 12.22M21.88 3.12c3.05 0 6.25 4.07 7.73 10.67-5.13-.68-10.33-.68-15.47 0 1.49-6.6 4.69-10.67 7.73-10.67Zm-7.26 1.47c-1.91 2.97-3.2 6.3-3.78 9.78-2.44.47-4.81 1.29-7.01 2.44 1.56-5.5 5.53-9.99 10.79-12.22m-4.26 13.1c-.14 1.35-.21 2.75-.21 4.19s.07 2.83.21 4.19c-4.59-1.15-7.24-2.85-7.24-4.19s2.65-3.04 7.24-4.19m-6.53 9.25c2.21 1.15 4.57 1.97 7.01 2.44.58 3.48 1.87 6.81 3.78 9.78A18.84 18.84 0 0 1 3.83 26.94m10.31 3.02c2.56.34 5.15.52 7.73.51 2.59 0 5.17-.17 7.73-.51-1.49 6.6-4.69 10.67-7.73 10.67s-6.25-4.07-7.73-10.67",
    style: {
      fill: "url(#icon_ping_(1)_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.29 25h4.1a10.2 10.2 0 0 1 0-3.12h-4.1c-.86 0-1.56.7-1.56 1.56s.7 1.56 1.56 1.56",
    style: {
      fill: "url(#icon_ping_(1)_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.56 35.04a10.2 10.2 0 0 1-3.12 0v4.1c0 .86.7 1.56 1.56 1.56s1.56-.7 1.56-1.56z",
    style: {
      fill: "url(#icon_ping_(1)_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.58 75h-4.1a10.2 10.2 0 0 1 0 3.12h4.1c.86 0 1.56-.7 1.56-1.56S38.44 75 37.58 75",
    style: {
      fill: "url(#icon_ping_(1)_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88 59.29c-.86 0-1.56.7-1.56 1.56v4.1a10.2 10.2 0 0 1 3.12 0v-4.1c0-.86-.7-1.56-1.56-1.56",
    style: {
      fill: "url(#icon_ping_(1)_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 32.03c4.75 0 8.59-3.85 8.59-8.59s-3.85-8.59-8.59-8.59-8.59 3.85-8.59 8.59 3.85 8.59 8.59 8.59m0-14.06c3.02 0 5.47 2.45 5.47 5.47s-2.45 5.47-5.47 5.47-5.47-2.45-5.47-5.47 2.45-5.47 5.47-5.47",
    style: {
      fill: "url(#icon_ping_(1)_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.88 67.97c-4.75 0-8.59 3.85-8.59 8.59s3.85 8.59 8.59 8.59 8.59-3.85 8.59-8.59-3.85-8.59-8.59-8.59m0 14.06c-3.02 0-5.47-2.45-5.47-5.47s2.45-5.47 5.47-5.47 5.47 2.45 5.47 5.47-2.45 5.47-5.47 5.47",
    style: {
      fill: "url(#icon_ping_(1)_svg2__k)"
    }
  }));
};
export default SvgIconPing1;